<div class="sidebar-header-container flex flex-col items-center justify-center">
	<img src="../../../../../../assets/avatar.png" alt="" class="mb-3 text-sm" />
	<p>Bienvenido</p>
	<h2 class="text-">{{ 'user@mail.com' }}</h2>
	<h2>Empresa</h2>
</div>
